import { render, staticRenderFns } from "./LgFinderPageTipoManutencaoIBP.vue?vue&type=template&id=2a220188"
import script from "./LgFinderPageTipoManutencaoIBP.vue?vue&type=script&lang=js"
export * from "./LgFinderPageTipoManutencaoIBP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports